import type { InterestZoneRun, InterestZoneRunWithUrl } from '@gozoki/api-types'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  deleteInterestZoneRun,
  startInterestZoneRun,
} from '../mutations/interestZoneRuns.mutations'
import { fetchInterestZoneRun, fetchInterestZoneRuns } from '../queries/interestZoneRuns.queries'

const KEYS = {
  list: ['interest-zone-runs'] as const,
  detail: (key: string) => ['interest-zone-runs', key] as const,
}

export const useInterestZoneRuns = () =>
  useQuery<InterestZoneRun[]>({
    queryKey: KEYS.list,
    queryFn: fetchInterestZoneRuns,
  })

export const useInterestZoneRun = (key: string | null) =>
  useQuery<InterestZoneRunWithUrl>({
    queryKey: KEYS.detail(key ?? ''),
    queryFn: () => fetchInterestZoneRun(key!),
    enabled: !!key,
  })

export const useStartInterestZoneRun = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: startInterestZoneRun,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.list })
    },
  })
}

export const useDeleteInterestZoneRun = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: deleteInterestZoneRun,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.list })
    },
  })
}
